"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IceMoonColony = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const BuildColony_1 = require("../../deferredActions/BuildColony");
const PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
const Card_1 = require("../Card");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class IceMoonColony extends Card_1.Card {
    constructor() {
        super({
            cost: 23,
            tags: [Tags_1.Tags.SPACE],
            name: CardName_1.CardName.ICE_MOON_COLONY,
            cardType: CardType_1.CardType.AUTOMATED,
            tr: { oceans: 1 },
            metadata: {
                cardNumber: 'C15',
                renderData: CardRenderer_1.CardRenderer.builder((b) => b.colonies(1).oceans(1)),
                description: 'Place 1 colony and 1 ocean tile.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        const canBuildColony = player.hasAvailableColonyTileToBuildOn();
        if (!canBuildColony)
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select colony for Ice Moon Colony'));
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select ocean for Ice Moon Colony'));
        return undefined;
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, oceansToPlace: 1 });
    }
}
exports.IceMoonColony = IceMoonColony;
//# sourceMappingURL=IceMoonColony.js.map